import React from 'react';
import styled from 'styled-components';
import { SecondaryButton } from '../Button';
import { theme } from '../../styles/theme';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { builderToggleShowLumosPrompt } from '../../redux/slices/oldBuilder';
import { selectOpenedModalType } from '../../redux/selectors/modal';
import { ModalSliceType, openModal } from '../../redux/slices/modal';
import ConfigureLumosModal from './ConfigureLumosModal';
import useBuilderSelector from '../../redux/selectorHooks/useBuilderSelector';
import { useBootstrapSelector } from '../../redux/selectorHooks';

const Container = styled(SecondaryButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-color: ${theme.colors.purple500};
  color: ${theme.colors.purple500};
`;

const LumosButton = () => {
  const dispatch = useAppDispatch();
  const isConfigureLumosModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.ConfigureLumos, ''),
  );

  const { isPromptVisible } = useBuilderSelector('llmContext');
  const llmApiEnabled = useBootstrapSelector('llmApiEnabled');

  const handleClick = () => {
    if (llmApiEnabled) {
      dispatch(builderToggleShowLumosPrompt(true));
    } else {
      dispatch(
        openModal({
          type: ModalSliceType.ConfigureLumos,
          id: '',
          data: {},
        }),
      );
    }
  };

  const shouldShowLumosButton = !isPromptVisible || !llmApiEnabled;

  return (
    <>
      {shouldShowLumosButton && (
        <Container type="button" isOutlined={true} onClick={handleClick}>
          Ask Lumos
        </Container>
      )}
      {isConfigureLumosModalOpen && <ConfigureLumosModal />}
    </>
  );
};

export default LumosButton;
